var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"default~app-pages-pages-module~auth-auth-module",
		"auth-auth-module"
	],
	"./client/client.module": [
		"./src/app/pages/client/client.module.ts",
		"default~client-client-module~user-user-module",
		"client-client-module"
	],
	"./user/user.module": [
		"./src/app/pages/user/user.module.ts",
		"default~client-client-module~user-user-module",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;